const clock = document.getElementById("utc-clock")

if (clock) {
  const tick = () => {
    const now = new Date()
    const time = now.toISOString().slice(11, 19)
    const date = now
      .toLocaleDateString("en-GB", { timeZone: "UTC", day: "2-digit", month: "short", year: "2-digit" })
      .replaceAll(" ", "-")
    clock.textContent = `${time}Z ${date}`
  }
  tick()
  setInterval(tick, 1000)
}
